type LabeledNavItem = {
  label: string;
};

/** Reserved for global app chords on person profile pages (Add menu and My Tasks). */
export const PERSON_PROFILE_SIDEBAR_RESERVED_HOTKEYS = new Set(["A", "T"]);

export function getHotkeyCandidates(label: string): string[] {
  const candidates: string[] = [];
  const words = label.trim().split(/\s+/).filter(Boolean);

  for (const word of words) {
    if (word[0]) {
      candidates.push(word[0].toUpperCase());
    }
  }

  for (const word of words) {
    for (let index = 1; index < word.length; index += 1) {
      candidates.push(word[index].toUpperCase());
    }
  }

  return candidates;
}

export function assignHotkeyForLabel(label: string, usedHotkeys: Set<string>): string | undefined {
  for (const candidate of getHotkeyCandidates(label)) {
    if (!usedHotkeys.has(candidate)) {
      usedHotkeys.add(candidate);
      return candidate;
    }
  }

  return undefined;
}

export function assignHotkeysToNavLinks<T extends LabeledNavItem>(
  navLinks: T[],
  { reservedHotkeys = new Set<string>() }: { reservedHotkeys?: Set<string> } = {}
): Array<T & { hotkey?: string }> {
  const usedHotkeys = new Set(reservedHotkeys);

  return navLinks.map((navLink) => {
    const hotkey = assignHotkeyForLabel(navLink.label, usedHotkeys);

    return hotkey ? { ...navLink, hotkey } : navLink;
  });
}
